<script>
import axios from "axios";

export default {

    data() {
        return {
            
            category_new: '',
            color_new: '',
            model_new: '',
            capacity_new: '',
            brandName:'',
            brands:[],

            isbrandnew:'',
        };
    },

    methods: {
        listBrands() {
            axios.defaults.headers.common["authorization"] = "Bearer " + localStorage.getItem("jwt");
            axios.get(process.env.VUE_APP_API_BASEURL + "brand/list")
            .then((response) => {
                console.log(response);
                if (response.status === 200) {
                    this.brands = response.data;
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },

        addCategoryForm() {
            this.loading = true;
            const formData = new FormData();
            formData.append("name", this.category_new);
            axios.defaults.headers.common["authorization"] = "Bearer " + localStorage.getItem("jwt");
            axios.post(process.env.VUE_APP_API_BASEURL + "product/category/create", formData)
            .then((response) => {
                console.log(response);
                if (response.status === 200) {
                    this.$emit('category-added',response.data.id);
                    alert("Category Created Successfully");
                    const closeModalButton = document.getElementById('closeModal');
                    if (closeModalButton) {
                        closeModalButton.click();
                    }
                }
            })
            .catch((error) => {
                // Handle error responses (such as 409 Conflict)
                if (error.response) {
                    if (error.response.status === 409) {
                        alert(error.response.data.message);
                    } else {
                        alert("An unexpected error occurred");
                    }
                } else {
                    alert("Network error, please try again");
                }
            })
            .finally(() => {
                this.loading = false;
            });
        },

        addModelForm() {
            this.loading = true;
            const formData = new FormData();
            formData.append("name", this.model_new);
            formData.append("brand", this.brandName);
            formData.append("isbrandnew", this.isbrandnew ? 1 : 0);
            axios.defaults.headers.common["authorization"] = "Bearer " + localStorage.getItem("jwt");
            axios.post(process.env.VUE_APP_API_BASEURL + "product/model/create", formData)
            .then((response) => {
                console.log(response);
                if (response.status === 200) {
                    this.$emit('model-added',response.data.id);
                    alert("Model Created Successfully");
                    this.listBrands();
                    const closeModalButton = document.getElementById('closeModel');
                    if (closeModalButton) {
                        closeModalButton.click();
                    }
                }
            })
            .catch((error) => {
                // Handle error responses (such as 409 Conflict)
                if (error.response) {
                    if (error.response.status === 409) {
                        alert(error.response.data.message);
                    } else {
                        alert("An unexpected error occurred");
                    }
                } else {
                    alert("Network error, please try again");
                }
            })
            .finally(() => {
                this.loading = false;
            });
        },


        addCapacityForm() {
            this.loading = true;
            const formData = new FormData();
            formData.append("name", this.capacity_new);
            axios.defaults.headers.common["authorization"] = "Bearer " + localStorage.getItem("jwt");
            axios.post(process.env.VUE_APP_API_BASEURL + "product/capacity/create", formData)
            .then((response) => {
                console.log(response);
                if (response.status === 200) {
                    this.$emit('capacity-added',response.data.id);
                    alert("Capacity Created Successfully");
                    const closeModalButton = document.getElementById('closeCapacity');
                    if (closeModalButton) {
                        closeModalButton.click();
                    }
                }
            })
            .catch((error) => {
                // Handle error responses (such as 409 Conflict)
                if (error.response) {
                    if (error.response.status === 409) {
                        alert(error.response.data.message);
                    } else {
                        alert("An unexpected error occurred");
                    }
                } else {
                    alert("Network error, please try again");
                }
            })
            .finally(() => {
                this.loading = false;
            });
        },
        

        addColorForm() {
            this.loading = true;
            const formData = new FormData();
            formData.append("name", this.color_new);
            axios.defaults.headers.common["authorization"] = "Bearer " + localStorage.getItem("jwt");
            axios.post(process.env.VUE_APP_API_BASEURL + "product/color/create", formData)
            .then((response) => {
                console.log(response);
                if (response.status === 200) {
                    this.$emit('color-added',response.data.id);
                    alert("Color Created Successfully");
                    const closeModalButton = document.getElementById('closeColor');
                    if (closeModalButton) {
                        closeModalButton.click();
                    }
                }
            })
            .catch((error) => {
                // Handle error responses (such as 409 Conflict)
                if (error.response) {
                    if (error.response.status === 409) {
                        alert(error.response.data.message);
                    } else {
                        alert("An unexpected error occurred");
                    }
                } else {
                    alert("Network error, please try again");
                }
            })
            .finally(() => {
                this.loading = false;
            });
        },
    },
    mounted () {
        this.listBrands();
    },
    
}
</script>

<template>
    <div class="modal fade" id="addCategoryModal" tabindex="-1" aria-labelledby="addCategoryModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="addCategoryModalLabel">Add New Category</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form id="addCategoryForm">
                        <div class="mb-3">
                            <label for="categoryName" class="form-label">Category Name</label>
                            <input type="text" class="form-control" v-model="category_new" id="categoryName" placeholder="Enter category name" required>
                        </div>
                    <!-- Add other fields here if needed -->
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="closeModal">Close</button>
                    <button type="submit" @click="addCategoryForm" class="btn btn-primary">Save Category</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="addModelModal" tabindex="-1" aria-labelledby="addModelModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="addModelModalLabel">Add New Model</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form id="addCategoryForm">
                        <div class="mb-3">
                            <label for="categoryName" class="form-label">Model Name</label>
                            <input type="text" class="form-control" v-model="model_new" id="categoryName" placeholder="Enter Model name" required>
                        </div>
                        <div class="mb-3">
                            <label for="categoryName" class="form-label">Brand Name</label>
                            <input type="text" class="form-control" v-model="brandName" id="categoryName" placeholder="Enter Brand name" v-if="isbrandnew" required>
                            <select v-model="brandName" class="form-select mb-3" arial-label="Default select example" v-else required>
                                <option value="">--- Select Brand ---</option>
                                <option v-for="(item, index) in brands" :key="index" :value="item.id" >
                                    {{ item.name }}
                                </option>
                            </select>
                            
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" v-model="isbrandnew" /> Click if new brand
                            </div>
                        </div>
                        
                    <!-- Add other fields here if needed -->
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="closeModel">Close</button>
                    <button type="submit" @click="addModelForm" class="btn btn-primary">Save Model</button>
                </div>
            </div>
        </div>
    </div>
    
    <div class="modal fade" id="addCapacityModal" tabindex="-1" aria-labelledby="addCapacityModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="addCapacityModalLabel">Add New Capacity</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form id="addCategoryForm">
                        <div class="mb-3">
                            <label for="categoryName" class="form-label">Capacity Name</label>
                            <input type="text" class="form-control" v-model="capacity_new" id="categoryName" placeholder="Enter Capacity name" required>
                        </div>
                    <!-- Add other fields here if needed -->
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="closeCapacity">Close</button>
                    <button type="submit" @click="addCapacityForm" class="btn btn-primary">Save Capacity</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="addColorModal" tabindex="-1" aria-labelledby="addColorModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="addColorModalLabel">Add New Color</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form id="addCategoryForm">
                        <div class="mb-3">
                            <label for="categoryName" class="form-label">Color Name</label>
                            <input type="text" class="form-control" v-model="color_new" id="categoryName" placeholder="Enter Color name" required>
                        </div>
                    <!-- Add other fields here if needed -->
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="closeColor">Close</button>
                    <button type="submit" @click="addColorForm" class="btn btn-primary">Save Color</button>
                </div>
            </div>
        </div>
    </div>
</template>